import React from "react";
import { CheckCircle, XCircle, Play, Pause, Flag, Lock, UserPlus, UsersThree, ArrowUUpLeft } from "@phosphor-icons/react";
import { Action } from "@/components/job/JobAction";

/** Status-driven job lifecycle toolbar (approve/reject/assign/start/complete/close…). */
export function JobActionsBar({
  job, isApprover, canAssignDirect, isAssignee, canSendForApproval, canAccept,
  assignTo, approverId, setApproverId, approverUsers,
  showMulti, setShowMulti, comments, actualCost, busy, act, setErr,
}) {
  const promptReturn = () => {
    const reason = window.prompt("Return reason (required):");
    if (reason && reason.trim()) act("return", { reason: reason.trim() });
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="job-actions">
      {job.status === "pending_approval" && isApprover && (
        <>
          <Action testid="job-approve-button" icon={CheckCircle} label="Approve" onClick={() => act("approval", { decision: "approved", comments, assigned_to_id: assignTo || null })} disabled={busy} />
          <Action testid="job-reject-button" icon={XCircle} label="Reject" variant="danger" onClick={() => act("approval", { decision: "rejected", comments })} disabled={busy} />
        </>
      )}
      {(job.status === "submitted" || job.status === "approved") && canAssignDirect && (
        <>
          <Action testid="job-assign-button" icon={UserPlus} label="Assign" onClick={() => assignTo ? act("assignment", { assigned_to_id: assignTo }) : setErr("Select a technician first.")} disabled={busy} />
          <Action testid="job-multi-assign-toggle" icon={UsersThree} label={showMulti ? "Single assign" : "Multi-assign"} variant="outline" onClick={() => setShowMulti(!showMulti)} disabled={busy} />
        </>
      )}
      {(job.status === "assigned" || job.status === "in_progress") && canAssignDirect && (
        <Action testid="job-reassign-button" icon={UserPlus} label="Reassign" variant="outline" onClick={() => assignTo ? act("assignment", { assigned_to_id: assignTo }) : setErr("Pick a technician to reassign to.")} disabled={busy} />
      )}
      {canSendForApproval && (
        <div className="flex items-center gap-2">
          <select value={approverId} onChange={e => setApproverId(e.target.value)} data-testid="job-approver-select"
            className="rmms-input h-10 w-auto min-w-[150px] text-sm">
            <option value="">All approvers</option>
            {approverUsers.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
          <Action testid="job-send-approval-button" icon={Flag} label="Send for approval" variant="outline"
            onClick={() => act("request-approval", { approver_id: approverId || null })} disabled={busy} />
        </div>
      )}
      {canAccept && (
        <Action testid="job-accept-button" icon={CheckCircle} label="Accept" onClick={() => act("accept")} disabled={busy} />
      )}
      {job.status === "assigned" && isAssignee && (
        <Action testid="job-start-button" icon={Play} label="Start work" onClick={() => act("start")} disabled={busy} />
      )}
      {job.status === "in_progress" && isAssignee && (
        <>
          <Action testid="job-complete-button" icon={Flag} label="Complete" onClick={() => act("complete", { actual_cost: Number(actualCost), notes: comments })} disabled={busy} />
          <Action testid="job-pause-button" icon={Pause} label="Pause" variant="warn" onClick={() => {
            const reason = window.prompt("Pause reason (required):\n• Waiting for parts\n• Awaiting approval\n• Store inaccessible\n• Additional work required\n• Other (specify)");
            if (reason && reason.trim()) act("pause", { reason: reason.trim() });
          }} disabled={busy} />
          <Action testid="job-return-button" icon={ArrowUUpLeft} label="Return" variant="danger" onClick={promptReturn} disabled={busy} />
        </>
      )}
      {job.status === "paused" && isAssignee && (
        <>
          <Action testid="job-resume-button" icon={Play} label="Resume" onClick={() => act("resume")} disabled={busy} />
          <Action testid="job-return-button" icon={ArrowUUpLeft} label="Return" variant="danger" onClick={promptReturn} disabled={busy} />
        </>
      )}
      {job.status === "completed" && isApprover && (
        <Action testid="job-close-button" icon={Lock} label="Close" onClick={() => act("close")} disabled={busy} />
      )}
    </div>
  );
}
